import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../SharedComponents/Loader/Loader";
import { Col, Modal, Row } from "antd";
import classes from "../Modal.module.css";
import CommonButton from "../../Components/Buttons/CommonButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  EmailExp,
  MobileExp,
  PasswordExp,
  lengths,
} from "../../Shared/Constants";
import {
  AvoidSpace,
  CatchMessage,
  JSONtoformdata,
  Phone_Number_Validation,
  PreventPasting,
  ValidinputData,
  avoidletters,
  tokenisValid,
} from "../../Shared/Methods";
import CommonInputTwo from "../../Components/CommonForms/CommonInputTwo";
import CommonPasswordInput from "../../Components/CommonForms/CommonPasswordInput";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { toast } from "react-toastify";
import {
  createMailSettings,
  CreateUserData,
  deviceDropdown,
  meterDropdown,
  updateMailSettings,
  UpdateUserData,
} from "../../Services/ApiServices";
import Commonselectfield from "../../Components/CommonForms/CommonSelectField";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";

const validation = Yup.object().shape({
  fromdate: Yup.string()
    .matches(
      /^(0?[1-9]|[12][0-9]|3[01])$/,
      "From Date must be between 1 and 31"
    )
    .required("From Date is required"),
  todate: Yup.string()
    .matches(/^(0?[1-9]|[12][0-9]|3[01])$/, "To Date must be between 1 and 31")
    .required("To Date is required"),
  device_id: Yup.string().when("Action", {
    is: (Action: string) => Action === "Create",
    then: (schema) => schema.required("Device is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

interface props {
  handleSuccess: (type: string) => void;
  Action?: string;
  item?: any;
  open: boolean;
  closable: boolean;
  onCancel: () => void;
}

interface formikprops {
  name: string;
  username: string;
  email: string;
  mobile_no: string;
  alternative_no: string;
  password: string;
  ispassword: boolean;
}

function AddMailSettings({
  handleSuccess,
  Action,
  item,
  open,
  closable,
  onCancel,
}: props) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const dispatch = useDispatch();
  const [deviceList, setDeviceList] = useState<any>([]);
  const [meterList, setMeterList] = useState<any>([]);
  const dateList = [...new Array(31)].map((_, ele: any) => ({
    id: ele + 1,
    value: ele + 1,
    label: ele + 1,
  }));
  // for (let i = 2; i <= 31; i++) {
  //   dateList.push({ id: i, value: i, label: i });
  // }
  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    errors,
    touched,
    setValues,
  } = useFormik({
    initialValues: {
      device_id: null,
      meter_ids: null,
      fromdate: "",
      todate: "",
      Action: Action,
    },
    validationSchema: validation,
    onSubmit: (values) => {
      if (Action === "Create") {
        handleAddUser();
      } else {
        handleUpdateUser();
      }
    },
  });

  useEffect(() => {
    if (item?.mail_settings_id) {
      setValues({
        ...values,
        device_id: item?.device_id || "",
        meter_ids: item?.meter_id || "",
        fromdate: item?.fromdate || "",
        todate: item?.todate || "",
      });
    }
  }, [item]);

  useEffect(() => {
    if (LoginData !== null) {
      handleDeviceDropDown();
    }
  }, [LoginData]);

  useEffect(() => {
    if (values?.device_id) {
      handleMeterDropDown();
    } else {
      setFieldValue("meter_id", "");
    }
  }, [values?.device_id]);

  console.log("item", errors);

  const handleDeviceDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      user_id: LoginData?.userId,
    };

    deviceDropdown(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          const device = res.data.data.map((ele: any, ind: number) => {
            return { value: ele?.deviceId, label: ele?.deviceName };
          });
          setDeviceList(device);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  console.log("date", dateList);

  const handleMeterDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: values?.device_id,
    };

    meterDropdown(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          const meter = res.data.data.map((ele: any, ind: number) => {
            return { value: ele?.id, label: ele?.meter_name };
          });
          setMeterList(meter);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const handleAddUser = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
    };
    delete finalObj.Action;
    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.ispassword;

    createMailSettings(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess("create");
          toast.success(res?.data?.msg);
          onCancel();
        }
        if (res?.data?.status == 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const handleUpdateUser = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      mail_setting_ids: item?.mail_settings_id ? item?.mail_settings_id : item,
      ...values,
    };
    delete finalObj.Action;
    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.ispassword;

    updateMailSettings(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess("update");
          toast.success(res?.data?.msg);
          onCancel();
        }
        if (res?.data?.status == 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />

      <Modal open={open} closable={closable} width={900} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>{Action} Mail Settings</h4>

          <Row gutter={[16, 16]}>
            <Col xl={8} lg={12} md={24} sm={12} xs={24}>
              <Commonselectfield
                labelname="From Date"
                value={values.fromdate}
                onChange={(value) => {
                  setFieldValue("fromdate", value);
                }}
                required={true}
                style={{ width: "100%" }}
                options={dateList}
                size="large"
                touched={touched}
                error={errors}
                name="fromdate"
              />
            </Col>
            <Col xl={8} lg={12} md={24} sm={12} xs={24}>
              <Commonselectfield
                labelname="To Date"
                value={values.todate}
                onChange={(value) => {
                  setFieldValue("todate", value);
                }}
                required={true}
                style={{ width: "100%" }}
                options={dateList}
                size="large"
                touched={touched}
                error={errors}
                name="todate"
              />
            </Col>
            {Action === "Create" && (
              <>
                <Col xl={8} lg={12} md={24} sm={12} xs={24}>
                  <Commonselectfield
                    labelname="Device"
                    value={values.device_id}
                    onChange={(value) => {
                      setFieldValue("device_id", value);
                    }}
                    required={true}
                    style={{ width: "100%" }}
                    options={deviceList}
                    size="large"
                    touched={touched}
                    error={errors}
                    name="device_id"
                  />
                </Col>

                <Col xl={8} lg={12} md={24} sm={12} xs={24}>
                  <Commonselectfield
                    labelname="Meter"
                    value={values.meter_ids}
                    onChange={(value) => {
                      setFieldValue("meter_ids", value);
                    }}
                    style={{ width: "100%" }}
                    options={meterList}
                    size="large"
                    mode="multiple"
                    disabled={values?.device_id ? false : true}
                  />
                </Col>
              </>
            )}
          </Row>

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Submit"
              onClick={handleSubmit}
              type="submit"
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => onCancel()}
              style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AddMailSettings;
